export default __webpack_public_path__ + "0171f80c559dc942ab7dae7de8cc25e8.svg";